export interface ServiceConfig {
  endpoint: string;
  serviceAccount: string;
  cwRUMAppMonitorId: string;
  cwRUMIdentityPoolId: string;
  enableAdobeAnalytics: boolean;
}

export interface ClientConfig {
  howserService?: ServiceConfig;
}

export type FullClientConfig = {
  [P in keyof ClientConfig]: StageConfig<ClientConfig[P]>;
};

export type StageConfig<Config> = {
  [SKey in Stage]: Config;
};

export enum Region {
  US_EAST_1 = 'us-east-1',
}

export type ConfigOptions = {
  stage?: Stage;
};

export enum Stage {
  DEV = 'Dev',
  ALPHA = 'Alpha',
  BETA = 'Beta',
  GAMMA = 'Gamma',
  PROD = 'Prod',
}
